import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export const GoalsPageMetaOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);
